/* eslint-disable react/jsx-props-no-spreading */
import { FallbackProps } from 'react-error-boundary'

import { FatalError } from './FatalError/FatalError'
import { QueryErrorBoundary } from './QueryErrorBoundary'

export const withQueryErrorBoundary = <P,>(
  Component: React.ComponentType<P>,
  FallbackComponent: React.ComponentType<FallbackProps> = FatalError
): React.ComponentType<P> => {
  const Wrapped: React.ComponentType<P> = (props: P) => (
    <QueryErrorBoundary FallbackComponent={FallbackComponent}>
      <Component {...props} />
    </QueryErrorBoundary>
  )

  // format for display in DevTools
  const name = Component.displayName || Component.name || 'Unknown'
  Wrapped.displayName = `withErrorBoundary(${name})`

  return Wrapped
}
